








































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Payment } from '@/types/Payments'
import { completePayments } from '@/services/payments'

@Component
export default class CompletePaymentsDialog extends Vue {

  @Prop({ default: false }) opened!: boolean
  @Prop({ type: Array }) paymentIds!: number[]

  loading = false

  get payments() {
    return this.$store.getters.paymentsByIds(this.paymentIds)
  }

  get subtotal() {
    const total = this.payments.reduce((total: number, current: Payment) => {
      return total + (current ? parseFloat(current.amount) : 0)
    }, 0)

    return Math.round(total * 100) / 100
  }

  get fees() {
    const total = this.payments.reduce((total: number, current: Payment) => {
      return total + (current ? parseFloat(current.fee) : 0)
    }, 0)

    return Math.round(total * 100) / 100
  }

  get total() {
    return this.subtotal + this.fees
  }

  get countUniquePeople() {
    return this.payments.reduce((acc: any[], payment: Payment) => {
      if (!payment?.receiver?.id) return acc
      
      if (acc.indexOf(payment.receiver.id) === -1) {
        acc.push(payment.receiver.id)
      }
      return acc
    }, []).length
  }

  closeDialog() {
    this.$emit("update:opened", false);
  }
  
  async completePayments() {
    this.loading = true
    try {
      await completePayments(this.$store, this.paymentIds)
      this.closeDialog()
      this.$emit('completed')
    }
    finally {
      this.loading = false
    }
  }
}
